<template>
  <WidgetCard title="Plan utilisation" icon="dashboard" :loading="loading" :error="error" :empty="emptyMessage">
    <div v-if="ready" class="dw-dist">
      <div v-for="t in tiers" :key="t.key" class="dw-dist__row dw-dist__row--plan">
        <span class="dw-dist__label">{{ t.label }}</span>
        <span class="dw-dist__track">
          <span class="dw-dist__fill" :style="{ width: fillWidth(t), background: fillColor(t) }" />
        </span>
        <span class="dw-dist__pct">
          {{ t.used.toLocaleString() }}<template v-if="t.limit > 0"> / {{ t.limit.toLocaleString() }}</template>
        </span>
      </div>
      <div v-if="showDomain" class="dw-dist__row dw-dist__row--plan dw-dist__row--domain">
        <span class="dw-dist__label">Domain</span>
        <span class="dw-dist__track">
          <span class="dw-dist__fill" :style="{ width: fillWidth(domain), background: fillColor(domain) }" />
        </span>
        <span class="dw-dist__pct">
          {{ domain.used.toLocaleString() }}<template v-if="domain.limit > 0"> / {{ domain.limit.toLocaleString() }}</template>
        </span>
      </div>
    </div>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import DashboardService from '../../services/dashboard.service';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';

  export default {
    name: 'PlanUtilisationWidget',
    components: { WidgetCard },
    // Account-wide — deliberately not wired to the dashboard filters.
    mixins: [dashboardWidget],
    data() {
      return {
        tiers: [],
        domain: { used: 0, limit: 0, subscribed: false }
      };
    },
    computed: {
      // Shown whenever the account does domain monitoring at all, so a subscribed
      // account with a 0 limit still sees the bar rather than nothing.
      showDomain() {
        return Boolean(this.domain) && (this.domain.subscribed || this.domain.limit > 0 || this.domain.used > 0);
      },
      ready() {
        return !this.loading && !this.error && (this.tiers.length > 0 || this.showDomain);
      },
      emptyMessage() {
        return !this.loading && !this.error && this.tiers.length === 0 && !this.showDomain
          ? 'No plan tiers enabled'
          : '';
      }
    },
    methods: {
      cacheDescriptors() {
        return [DashboardService.resources.planUtil()];
      },
      pct(t) {
        return t.limit > 0 ? Math.round((t.used / t.limit) * 100) : 0;
      },
      fillWidth(t) {
        // Unlimited tiers (no limit) have no meaningful bar; show it empty.
        return `${Math.min(this.pct(t), 100)}%`;
      },
      // Blue with headroom, yellow approaching the cap, orange once met/exceeded.
      fillColor(t) {
        if (t.limit <= 0) return '#a9a9a9';
        const p = this.pct(t);
        if (p >= 100) return '#FF5A00';
        if (p >= 80) return '#f5c518';
        return '#1e88e5';
      },
      fetchResource() {
        return DashboardService.fetchPlanUtilisation();
      },
      applyResult(res) {
        this.tiers = res.tiers;
        this.domain = res.domain || { used: 0, limit: 0, subscribed: false };
      }
    }
  };
</script>
